export const COMPANY_START_DATE = new Date(1593545400000);  // epoc of "2020-07-01"
export const DEFAULT_TEACHER_COMMISSION = 20;
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://darsoon.com";
